import { getLink } from "../../../utils/utils";

const content = {
	esp: (
		`
		<p class="mb-3">
			Supozeble, ni vidas unuan provon de «revolucio de zombioj».
		</p>
		
		<p class="mb-3">
			Tio signifas, ke homoj ekstaras, tute influitaj de iu ekstera forto, eĉ ne sentante kaj ne agnoskante tion. 
			«Floraj revolucioj» antaŭe okazadis en mezgrandaj landoj kun multe da junularo, kun la popoloj, al kiuj efikis alvokoj sur placoj kaj en sociaj retoj. 
			Sed nia lando estas sufiĉe granda laŭ eŭropa skalo kaj, plej grave, en ĝi konserviĝis granda kvanto de popolo, naskita ankoraŭ en sovetia tempo; fakte, la tuta loĝantaro pli aĝa ol 25-30 jaroj. 
			Tiu popolo estas alkutimita kredi al amasmedioj: al radio, televido…
		</p>
		
		<p class="mb-3">
			Sed oni ne povas ekkonscii, ke la amasmedioj nun ĉiuj estas en la manoj de oligarĥoj, kaj parolas kaj disaŭdigas nur tion, kion tiuj diktas kaj permesas al ili. 
			Niaj ordinaraj homoj, pli aĝaj ol 30, kaj des pli pliaĝaj, ĉiutage kaj ĉiuhore spektas televidilon, kaj plene ensorbas tion, kion oni mesaĝas al ili. 
			Sed el televidiloj senlace kaj senĉese fluas ondego de influo, kiu penetras la cerbojn kaj poiomete, kiel guto malgranda konstante frapante, agordas ilin al la celata maniero. 
			Homoj ne plu pensas: ili respondas al demandoj per la citaĵoj, aŭditaj de amas-cerbolaviloj, eĉ ne rimarkante tion. 
			Iliaj cerboj jam estas plene prilavitaj, kaj ili agas tiel, kiel oni «ŝargis» ilin, arde kredante, ke estas ilia propra opinio. 
			Tio jam estas manipulebla armeo. 
			Armeo de «popola volo».
		</p>
		
		<p class="mb-3">
			Ĉi tie mi temas pri la popoltavolo, kun kiu mi plej ofte kontaktas: maljunaj virinoj-pensiulinoj, vendistinoj de ajna aĝo en vendejoj kaj bazaroj, malalta tavolo (ne gvidantoj) de edukaj kaj kulturaj instancoj. 
			Ili do amase ne havas proprajn ideojn kaj pensojn, kaj ripetas tion, kion ili aŭdis; en la nuna situacio tio estas: «Ni ne volas korupcion kaj ŝtelistojn», «Rusio, iru for!», «Ni estas ukrainanoj, kaj Ukrainio ne estas Rusio» (kaj ĉio tio en la rusa lingvo, certe). 
			Interese, ke la sloganon «Ni deziras al Eŭropo» la simpla popolo en Odessa ne ofte subtenas. 
			Ja en nia ĉelima kaj ĉemara urbo multaj jam estis en Eŭropo kaj propraokule vidis ĝin. 
			Eble, tio helpis kompreni la diferencon inter vidpunktoj de turisto – kaj de konstanta gast-laboranto tie.
		</p>
		
		<p class="mb-3">
			Do, tio pri konceptoj de pliaĝaj homoj. 
			Sed, kio pri junularo, kiu ĉiam, en ajna revolucio estas ĝia bruligilo kaj bruligaĵo? 
			Estas iom alia afero.
		</p>
		
		<p class="mb-3">
			Kiel vi scias, la Sovetunio ĉesis ekzisti en 1991; kaj jam dum 23 jaroj ĉe ni regas tio, kion en TV oni nomas «demokratio». 
			Kaj eble, vi iam aŭdis la epiteton, kiun oni tre ofte nun aplikas al 1990-aj jaroj; ĝi sonas proksimume kiel «rabiaj 90-aj». 
			Anstataŭ promesita demokratia paradizo post forskuo de terura totalitara reĝimo, ĉe ni ial, tute neatendite ekregis vere terura potenco de banditoj. 
			La grandan riĉan landon jam eblis disŝiri kaj disŝteli. Eble, vi scias, ekz., ke en USSR, pli ĝuste en Odessa troviĝis la plej granda en la mondo Nigramara Ŝipkompanio kun centoj da ŝipoj. 
			Sed dum kelkaj jaroj ĝi estis neniigita, kaj nun ne plu ekzistas. 
			Nun Ukrainio ne havas sian maran floton. 
			En Odessa unu triono de la loĝantaro estis iel ligita al ŝiparo, ŝipkonstruaj uzinoj, la havenaj entreprenoj ktp. 
			Jen ĉio malaperis, kaj la homoj fariĝis senlaboraj. 
			En 1992 oni anoncis «liberajn prezojn», kiuj tuj dekobliĝis; kaj sametempe oni ĉesis pagi salajrojn kaj pensiojn. 
			La prokrastigo de salajro povis atingi 5 monatojn! 
			Tre multaj mortis; aliuj serĉis ajnan laboron, sed la sola «laboro» estis re-vendi surstrate. 
			Homoj pensis nur pri tio, kiel elvivi kaj savi sin kaj siajn familiojn. 
			Oni laboradis po 10-12-14 horoj tage, en kelkaj laborlokoj, nur por havi iom da mono. 
			Vi imagas do, en kiu atmosfero vivis la tiam naskataj infanoj – tiuj, kiuj nun konsistigas la junularon.
		</p>
		
		<p class="mb-3">
			Jes, la gepatroj tiam ne povis zorgi pri ili. 
			Tamen, tio ne signifas, ke la infanaro-junularo restis en tiu tempo neprizorgita. 
			Tuj troviĝis tiuj, kiuj ekokupiĝis pri ĝi.
		</p>
		
		<p class="mb-5">
			Mi tiutempe miregis: kial, se la scienco, industrio, markomerco en la lando mortas (kio fakte signifas la morton de la potenco de la lando) – do kial la registaro tute ne atentas tion kaj nenion faras por preventi la katastrofon aŭ almenaŭ ion plibonigi la situacion. 
			La solaj vere firmaj ordonoj de la registaro koncernis tiam nur «kulturajn» aferojn: oni enkondukis ukrainan lingvon en lernejojn (simple neniigante la ruslingvajn lernejojn, konvertante ilin al la ukrainlingvaj), en universitatojn, en administrajn kaj juĝajn instancojn. 
			Mi dekomence ne komprenis: la homoj mortas pro malsato, banditoj interpafadas surstrate, industrio kaj scienco stagnas – kaj oni zorgas nur pri la lingvo! 
			Sed evidentiĝis, ke tio jam komenciĝis la preparo al la nuna «revolucio de zombioj», preparo de pure prilaboritaj vicoj de junularo, kies cerboj estas prilavitaj ekde naskiĝo. 
			Nun ili estas plene konvinkitaj, ke «Ukraina popolo estas la plej antikva en la mondo», ke ĝi ekzistis antaŭ centmiloj da jaroj; eble, eĉ Jesuo Kristo parolis ukraine… ktp. 
			Kaj ĉe ili, la ideo «aparteni al Eŭropo» havas sufiĉe grandan reeĥon, ĉar ili intencas elmigri tien, aŭ por labori, aŭ por ĉiam. 
			Klaras, ke tia situacio signifas nur, ke en ilia propra lando ne ekzistas taŭga loko por la junularo: nek laborlokoj, nek salajroj kontentigas ilin. 
			Sed tio tute ne atestas ilian patriotecon, ĉu ne? 
			Kial tiel arde strebi forlasi sian amatan patrujon?
		</p>
		
		<p class="mb-3">
			Sed la aferoj jam draste plivigliĝiĝis ekde la komenco de okazaĵoj sur la fama kieva placo. 
			Jes, la formala premiso por demonstracii estis «la fermo de la vojo al Eŭropo» kaj iom poste «la totala korupcio en Ukrainio». 
			Tamen, se rigardi iom atente, ni vidos, ke la afero estis majstre gvidata jam de antaŭe. 
			Dum ioma tempo, eble, dum la lasta jaro aŭ pli, en multaj amaskomunikiloj aperis informoj pri la krimoj de la milicio (nia polico). 
			Lertaj ĵurnalistoj disblovadis la fajron de popola malamo al milicistoj; kaj kiam ili ekagis kontraŭ la placanoj, la fajrego, jam zorge preparita, ekflamis tuj. 
			Evidentiĝis, ke ne la demonstraciantoj, kiuj bruligis la milicistojn, pikis ilin per alenoj sub la ŝildoj, tretis per buldozoj – ne, ne ili estas kulpaj! «Ili ja estas infanoj!»
		</p>
		
		<p class="mb-3">
			Kaj komenciĝis la vera milito, kiu daŭras jam pli ol 3 monatojn. 
			Milito kontraŭ la cerboj de nia popolo. 
			Ĉiuj aŭdaj, vidaj kaj paperaj amas-medioj en nia lando, mi ripetas, apartenas al oligarĥoj, kiuj havas fortajn rilatojn kun la registaro – ja aliel ili ne estus oligarĥoj kaj ne havus tian potencon. 
			Kaj ĝuste sian potencon ili ne volas perdi.
		</p>
		
		<p class="mb-3">
			Do, freneza inundo de misinformo por «interna uzado» en nia lando; kaj mi imagas, kiel pli potenca – por eksterlando, kie homoj ne povas informiĝi rekte.
		</p>
		
		<p class="mb-3">
			Ekde nun la amas-komunikiloj estas la ĉefaj batalantoj de tiu milito: ili verŝas la kerosenon al la fajro kaj disblovas ĝin. 
			Tion faras kaj niaj, kaj viaj eŭropaj ĵurnalistoj, kiuj kunflugas al ardanta loko. 
			Ĉu vi opinias, ke tio, kion oni montras al vi, estas vero? Kontrolu. 
			Trovu iun, kiu donas kontraŭan opinion, aliflankajn bildojn. 
			Ĉu trovis? Ĉu multaj? 
			Ĉu samkvantaj kun la kontraŭuloj, kiel decas en «libera, vera, konscienca ĵurnalismo», kiun oni predikas?
		</p>
		
		<p class="mb-3">
			Kaj tiu inundo konstante sin verŝas al la cerboj de simplaj homoj, kiuj jam senkonscie ensorbas ĝin. 
			Kaj nun ĝuste ili konsistigas la «revolucion de zombioj», apogante ĉiujn decidojn de la memproklamita «junto». 
			Homoj obeas al fortaj vokoj.
		</p>
		
		<p class="mb-3">
			Bonege subtenas tiun teorion la ĵusa ŝanĝo de guberniestroj de multaj regionoj. 
			La regantoj metis sur la ĉefpostenojn ĝuste la oligarĥojn, kiuj havas siajn proprajn «armeetojn» kaj, plej grave, kiuj povos perdi ĉion, se la popolo vere ekstaros kontraŭ la korupcio. 
			Do, la bela cirklo: la «revolucio» komenciĝis per alvokoj forigi la oligarĥojn, - kaj nun ĝuste la oligarĥoj, kiuj antaŭe havis nur latentan, financan forton, subite ekhavis jam la forton plenan, super kelkaj regionoj. 
			Sed la popolo ne rimarkas, ne konscias tion, kaj nun krias ĥore: «For Rusion!»
		</p>
		
		<p class="mb-3">
			Kiel plu disvolviĝos la revolucio de zombioj?
		</p>
		`
	)
}

const itemName = {
	esp: 'Revolucio de zombioj'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp
	}
}

export default item;